import { useQuery } from '@tanstack/react-query';
import Fetch from '../../../../../../core/util/core/Fetch';
import config from '../../../../../config/config';
import { getUserSession } from '../../../../../util/core/Session';
import { chooseProfileFilter } from "../../../../../helpers/chooseProfileFilter";

const useUnities = (cityId) => {
    const session = getUserSession();
    const profileFilter = chooseProfileFilter();

    const profile = session.user.application_profile_id;

    const isAdm = profile === config.default_foreign_key.profiles.zellusAdmin;

    const isClientManager =
        profile === config.default_foreign_key.sdg_profiles.clientManager;



    let filters = {
        core_application_instance_id: null
    };

    if (Object.keys(profileFilter).length > 0 && !isAdm) {
        filters = {
            ...profileFilter
        }
    } else if (session.user.application_instance_id && !isAdm) {
        filters = {
            core_application_instance_id: session.user.application_instance_id
        }
    }

    if (cityId) {
        filters = {
            ...filters,
            governance_room_client_city_id: cityId
        }
    }

    return useQuery({
        queryKey: ['unities-dashboard', cityId],
        queryFn: async () => {
            const unities = await Fetch.post(
                config.endpoints.backend +
                'governanceroom/dashboard/establishments',
                {
                    filters
                }
            );

            const unitiesMapped = unities.map((unity) => ({
                label: unity.no_fantasia,
                value: unity.co_cnes,
                governance_room_client_city_id: unity.id,
            }));

            const unitiesNotRepeated = new Set();
            const unitiesFiltered = unitiesMapped.filter((unity) => {
                if (unitiesNotRepeated.has(unity.value)) {
                    return false;
                }
                unitiesNotRepeated.add(unity.value);
                return true;
            });

            return unitiesFiltered || [];
        },
        enabled: !!cityId,
    });
};

export default useUnities;
